import { Col, Row } from "react-grid-system";
import { CreateUserForm } from "./CeateUserForm";

type CreateUserProps = {
	refetchUsers: () => void;
	closeModal: () => void;
};

export const CreateUser = (props: CreateUserProps) => {
	const { refetchUsers, closeModal } = props;
	return (
		<>
			<Row>
				<Col>
					<h2>Create user</h2>
				</Col>
			</Row>
			<Row style={{ marginTop: "1rem" }}>
				<Col>
					<CreateUserForm refetchUsers={refetchUsers} closeModal={closeModal} />
				</Col>
			</Row>
		</>
	);
};
